/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import MvnoBlockRequest from '../../../interfaces/platform/MvnoBlockRequest';
import { store } from '../../../core/store';
import { provConstant, provReducer } from '../../../modules/provisioning/ProvisioningConnect';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import MvnoBlockRequestState from '../../../interfaces/platform/MvnoBlockRequestState';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import ApiCollectionResponseInterface from '../../../interfaces/api/ApiCollectionResponseInterface';
import { Card, Typography } from '@material-ui/core';
import CardHeader from '../../../components/Card/CardHeader';
import I18n from '../../../components/Translate/I18n';
import CardBody from '../../../components/Card/CardBody';
import { DateHelper } from '../../../helpers/DateHelper';
import PlkViewList from './PlkViewList';

interface MvnoBlockRequestStateCollectionInterface extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<MvnoBlockRequestState> | null;
}

interface ApiBlockViewStateDetailProps {
    dispatch: any;
    item: MvnoBlockRequest;
}

interface ApiBlockViewStateDetailState {
    itemsState: MvnoBlockRequestStateCollectionInterface | null;
}

class ApiBlockViewStateDetail extends PureComponent<ApiBlockViewStateDetailProps, ApiBlockViewStateDetailState> {
    private loaderCall: ItemLoaders;

    constructor(props: ApiBlockViewStateDetailProps, context: ApiBlockViewStateDetailState) {
        super(props, context);
        store.injectReducer('provReducer', provReducer, false);
        this.loaderCall = new ItemLoaders(this.props.dispatch);
        this.state = {
            itemsState: null,
        };
    }

    componentDidMount(): void {
        this.loadRequestState();
    }

    componentWillUnmount(): void {
        this.setState({
            itemsState: null,
        });
    }

    loadRequestState = (): void => {
        const { item } = this.props;
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_request_states')),
            provConstant.MVNO_BLOCK_REQUEST_STATE_LIST,
            [{ name: 'mvnoBlockRequestId', value: item.id }],
            [{ name: 'id', value: 'asc' }],
            (data: MvnoBlockRequestStateCollectionInterface): void => {
                this.setState({
                    itemsState: data,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { itemsState } = this.state;
        const variant = 'subtitle2';

        return (
            <GridContainer>
                {itemsState &&
                    itemsState['hydra:member'] &&
                    itemsState['hydra:member'].map((state: MvnoBlockRequestState) => {
                        return (
                            <GridItem key={'mvno_request_state_key_' + state.id} xs={12}>
                                <Card>
                                    <CardHeader>
                                        <Typography variant={variant}>
                                            <I18n
                                                trans="prov:api.api_block_function_name"
                                                valueObject={{ function_name: state.mvnoBlockFunctionName }}
                                            />
                                        </Typography>
                                    </CardHeader>
                                    <CardBody>
                                        <Typography variant="body2">
                                            <I18n trans="prov:api.api_created_at" valueObject={{ createdAt: DateHelper.format(state.createdAt) }} />
                                        </Typography>
                                        {state.stepFinish && state.lastRequestProcessed && (
                                            <Typography variant="body2">
                                                <I18n
                                                    trans="prov:api.api_finish_at"
                                                    valueObject={{ finishAt: DateHelper.format(state.lastRequestProcessed) }}
                                                />
                                            </Typography>
                                        )}
                                    </CardBody>
                                    <CardBody>
                                        <PlkViewList item={state} />
                                    </CardBody>
                                </Card>
                            </GridItem>
                        );
                    })}
            </GridContainer>
        );
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(adescomStyle))(ApiBlockViewStateDetail);
